import React from 'react';
import { Link } from 'react-router-dom';
import { MovieBlock } from './MovieStyles';
import { imageUrl, posterSize } from '../api';
import { useGlobalContext } from '../../Context';
import playBtn from '../../imgs/svgs/playBtn.svg';
import addBtn from '../../imgs/svgs/addBtn.svg';
import rmvBtn from '../../imgs/svgs/rmvBtn.svg';
import castPlaceholder from '../../imgs/svgs/castPlaceHolder.svg';

const Movie = (props) => {
  const { id, title, overview } = props.movie;

  const { addToList, removeFromList } = useGlobalContext();

  let poster_path;
  if (props.movie.poster_path === null) {
    poster_path = castPlaceholder;
  } else {
    poster_path = `${imageUrl}${posterSize.s}${props.movie.poster_path}`;
  }

  return (
    <MovieBlock className='movieBlock'>
      <Link to={`/movie/${id}`}>
        <div className='img-wrapper'>
          <img className='movieThumbnail' src={poster_path} alt={title} />
          <div className='movieOverview'>
            <p>{overview.substring(0, 260)}...</p>
          </div>
        </div>
      </Link>
      <div className='details'>
        <h5>{title}</h5>

        <div className='btns'>
          {props.deleteBtn || (
            <button onClick={() => addToList(id)} className='addBtn round'>
              <img src={addBtn} alt='Add to my list' />
            </button>
          )}
          {props.deleteBtn && (
            <button
              onClick={() => removeFromList(id)}
              className='removeBtn round'
            >
              <img src={rmvBtn} alt='remove movie from list' />
            </button>
          )}
          <button className='playBtn round'>
            <img src={playBtn} alt='Play movie' />
          </button>
        </div>
      </div>
    </MovieBlock>
  );
};

export default Movie;
